export default __webpack_public_path__ + "static/media/druma_project.6e361064.JPG";